App.controller('ChangePasswordCtrl', ['$scope', '$sce', '$state', '$http', 'profileService', '$mdDialog', 'Config', '$base64', function ($scope, $sce, $state, $http, profileService, $mdDialog, Config, $base64) {
    $scope.page = 'profile';
    $scope.$emit('page', $scope.page);

    $scope.step = 'Zmiana hasła';
    $scope.$emit('step', $scope.step);

    $scope.link = 'root.home.profile';
    $scope.$emit('link', $scope.link);

    $scope.password = '';
    $scope.password_repeat = '';
    $scope.password_current = '';

    $scope.$watch('password', function () {
        if (!$scope.password) {
            $scope.strongPassword = 0;
            return 0;
        } else {
            $scope.strongPassword = $scope.password.length * 10 / 2;

            if ($scope.strongPassword <= 40) {
                $scope.strongPasswordLabel = 'Słabe';
            } else if ($scope.strongPassword <= 60) {
                $scope.strongPasswordLabel = 'Średnie';
            } else if ($scope.strongPassword <= 80) {
                $scope.strongPasswordLabel = 'Dobre';
            } else {
                $scope.strongPasswordLabel = 'Znakomite';
            }
        }
    });

    $scope.edit = function () {
        var vm = this;

        if (!vm.form.$valid) {
            return 0;
        }

        if ($scope.password !== $scope.password_repeat) {
            $scope.showPopUp('', 'Niezgodne hasła', 'Podane hasła nie są do siebie podobne.', '', '');
            return 0;
        }

        if ($scope.password.length && $scope.password_repeat.length && ($scope.password === $scope.password_repeat)) {
            $scope.data = {
                newPassword: $scope.password,
                confirmPassword: $scope.password_repeat,
                oldPassword: $scope.password_current
            }

            profileService.editPasswordUser($scope.data).then(function (data) {
                console.log(data);
                if (data.status === 200) {
                    // var email = JSON.parse(window.sessionStorage.getItem('userObject')).email;
                    // var token = $base64.encode(email + ':' + $scope.password);
                    // window.sessionStorage.setItem('token', token);

                    $scope.password = '';
                    $scope.password_repeat = '';
                    $scope.password_current = '';
                    vm.form.$setPristine();
                    vm.form.$setUntouched();
                    vm.form.$submitted = false;

                    $scope.showPopUp('', 'Hasło zostało zmienione', 'Twoje hasło zostało zmienione pomyślnie.', 'Przejdź do profilu', 'root.home.profile');
                } else {
                    $scope.showPopUp('', 'Niepoprawne hasło', 'Podane obecne hasło jest nieprawidłowe lub chcesz zmienić hasło na użyte wcześniej.', 'Ok', '');
                }
            });
        }
    }

    $scope.showPopUp = function (ev, head, content, text, target) {
        $mdDialog.show({
            controller: PopUpInfoCtrl,
            templateUrl: Config.TEMPLATES_DIR + 'PopUp/info-big.html',
            targetEvent: ev,
            clickOutsideToClose: true,
            locals: {
                head: head,
                content: content,
                button: {
                    text: text,
                    target: target
                }
            }
        }).then(function (data) {

        }, function () {

        });
    }

    function PopUpInfoCtrl(scope, $mdDialog, locals) {
        scope.locals = locals;

        scope.hide = function () {
            $mdDialog.hide();
        };

        scope.cancel = function () {
            $mdDialog.cancel();
        };

        scope.confirm = function () {
            $mdDialog.hide(scope.locals);
        };
    }
}]);